import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button} from 'antd';
import { Row, Col, Spinner, Alert } from 'reactstrap';
import axios from '../../utils/request';
import EmptyV from '@beisen-phoenix/themed-empty';
import FormEmpty from '@beisen-phoenix/themed-empty/lib/icons/Form';

let personIds = "";
let applyIds = "";
let jobIds = "";
let processId = "";
let tenantId = "";
let userId = "";

export class SunshineReferView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            personIds: "",
            applyIds : "",
            jobIds: "",
            processId: "",
            tenantId: "",
            userId: ""
        }
    };

    componentDidMount() {
        debugger
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let applicantId = urlParams.get("applicantId");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        //if (!commonParamater) {
        //    this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
        //    return;
        //}
        this.loadPage(tenantId, commonParamater, applicantId);
    };

    loadPage = (tenantId, commonParamater, applicantId) => {
        const params = {
            tenantId,
            commonParamater,
            applicantId

        }
        axios
            .get("/api/SunshineReferrer/GetReferrerInformationView", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = null;
                if (!isSuccessValue) {
                    errorMessage = "";
                } else {
                    if (resdata !== "") {
                        errorMessage = null;
                        window.location.href = resdata.baseurl;
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            return (
                <div style={{ height: '100vh', background: '#fff', margin: '0 -15px', paddingTop: '50px' }}>
                    <div style={{ textAlign: 'center' }}>
                        <EmptyV image={<FormEmpty openChangeSkin={true} />} description={"这里什么都没有..."} size={'large'} />
                    </div>
                </div>
            );
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight:"100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}